// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"room__Header__wrapper___Jjichw","titleArea":"room__Header__titleArea___2sFOKt","logo":"room__Header__logo___3eZO7V","title":"room__Header__title___2Xg4e3"};